module.exports = require("node:readline");